// Technical storage limits, NOT recommended intake or safety thresholds.
export const DAILY_CALORIE_TARGET_MAX = 20000;
export function validDailyCalorieTarget(value) {
    return Number.isFinite(value) && Number.isInteger(value) && value >= 1 && value <= DAILY_CALORIE_TARGET_MAX;
}
export const ACTIVITY_OPTIONS = [
    { value: 1.4, label: 'Мало движения', hint: 'В основном сидя, мало ходьбы' },
    { value: 1.6, label: 'Лёгкая активность', hint: 'Сидячий день, прогулки и немного занятий' },
    { value: 1.8, label: 'Активный день', hint: 'Много ходьбы или подвижная работа' },
    { value: 2.2, label: 'Высокая активность', hint: 'Тяжёлая физическая работа или большой объём нагрузок' },
];
/** Approximation, not a clinical target: Mifflin REE × explicitly selected activity.
 * Mifflin 1990 doi:10.1093/ajcn/51.2.241; activity categories FAO y5686e §5.
 * REE is not measured BMR; category factors add uncertainty. No weight-change adjustment.
 */
export function estimateMaintenance(input) {
    const { age, sex, heightCm, weightKg, activity, goal } = input;
    if (!Number.isInteger(age) || age < 18 || age > 100 || !['male', 'female'].includes(sex)
        || !Number.isFinite(heightCm) || heightCm < 100 || heightCm > 250
        || !Number.isFinite(weightKg) || weightKg < 30 || weightKg > 300
        || !ACTIVITY_OPTIONS.some(option => option.value === activity)
        || !['maintain', 'mass', 'cut'].includes(goal))
        return null;
    const ree = 10 * weightKg + 6.25 * heightCm - 5 * age + (sex === 'male' ? 5 : -161);
    const result = Math.round(ree * activity);
    return validDailyCalorieTarget(result) ? result : null;
}
//# sourceMappingURL=calorie.js.map